import { createSelector } from 'reselect'

import { 
	getCurrentUser,
} from 'state/selectors'

import {
	processNotificationList
} from 'utils'

export const getNotificationList = createSelector(
	[
		state => getCurrentUser(state),
		state => state.account.entities
	], (user, entities) => {
		user.notifications.sort((a, b) => { b - a })

		const notificationsList = processNotificationList(user.notifications, entities)

		notificationsList.sort((a,b) => {
			return b.object.created_at.localeCompare(a.object.created_at)
		})

		let notifyingAccounts = []

		notificationsList.forEach(notification => {
			if(notifyingAccounts.indexOf(notification.object.account_id) == -1){
				notifyingAccounts.push(notification.object.account_id)
			}
		})

		return {
			notifications: notificationsList,
			shouldShowAccounts: notifyingAccounts.length > 1
		}
	}
)